import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom'
import history from './history'
import { Provider } from 'react-redux';
import { store } from './store';
import * as viewsConstants from './constants/views'

//CSS
import './App.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'semantic-ui-css/semantic.min.css';
import 'react-datepicker/dist/react-datepicker.css';

// VIEWS
import TrainingRegister from './views/training_register'
import LoginPage from './views/login'
import ResetPassword from './views/password/reset';
import ChangePassword from './views/password/change';

class App extends Component {
  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <div className="App">
            <Route exact path={ viewsConstants.LOGIN_PATH } component={ LoginPage }/>
            <Route exact path={ viewsConstants.TRAINING_REGISTER_PATH } component={ TrainingRegister }/>
            <Route exact path={ viewsConstants.PASSWORD_RESET_PATH } component={ ResetPassword }/>
            <Route exact path={ viewsConstants.PASSWORD_CHANGE_PATH } component={ ChangePassword }/>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js